<template>
  <v-container fluid>
    <!-- <el-overlay-loading :loading="pageloading" /> -->
    <h3 class="mb-5">NTR teisių tipai ir potipiai</h3>

    <v-data-table
      :headers="filteredHeaders"
      :items="itemsList"
      :loading="loading"
      :search="search"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: 'Rodyti po:',
        itemsPerPageAllText: 'visi',
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :hide-default-footer="hideFooter"
      :page.sync="page"
      :items-per-page="pageSize"
    >
      <template #top>
        <v-toolbar flat>
          <v-text-field
            v-model="search"
            prepend-icon="mdi-magnify"
            label=""
            single-line
            hide-details
          ></v-text-field>
        </v-toolbar>
      </template>
      <template #[`item.pazymeta`]="{ item }">
        <el-switch v-model="item.pazymeta" @click.native="saveData(item)" />
      </template>
      <template slot="loading">
        Kraunasi...
      </template>
      <template slot="no-results">
        Duomenų nėra
      </template>
      <template slot="no-data">
        Duomenų nėra
      </template>
      <template #[`footer.page-text`]="props">
        Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
        {{ props.itemsLength }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import print from '../../mixins/print'

export default {
  name: 'AdminTeises',
  mixins: [print],
  data() {
    return {
      pageloading: true,
      loading: true,
      formData: [],
      search: null,
      itemsPerPageOptions: [10, 50, -1],
      pageSize: 10,
      page: 1,
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Aktyvus',
          align: 'center',
          value: 'pazymeta',
          width: 100,
        },
        {
          text: 'Teisės potipis',
          align: 'start',
          sortable: true,
          value: 'teip_potipis',
        },
        {
          text: 'Teisės potipio pavadinimas',
          align: 'start',
          sortable: true,
          value: 'teip_pav_i',
        },
        {
          text: 'Teisės tipas',
          align: 'start',
          sortable: true,
          value: 'teit_tipas',
        },
        {
          text: 'Teisės tipo pavadinimas',
          align: 'start',
          sortable: true,
          value: 'teit_pav_i',
        },
        {
          text: 'Galiojimas',
          align: 'start',
          sortable: true,
          value: 'teip_naudojama',
        },
        {
          text: 'Teisės asmuo',
          align: 'start',
          sortable: true,
          value: 'teip_poz',
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.formData.map((item, index) => {
        return item
      })
    },
    hideFooter() {
      return this.itemsList.length <= this.pageSize
    },
    isSearch() {
      return this.search != null && this.search.length > 0
    },
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.pageloading = true
      this.loading = true

      this.$axios
        .get(`admin/teise`)
        .then(res => {
          this.formData = res.data.teises
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    saveData(item) {
      this.loading = true

      const data = {
        teit_tipas: item.teit_tipas,
        teip_potipis: item.teip_potipis,
        pazymeta: item.pazymeta,
      }

      this.$axios
        .post(`admin/teise`, data)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    cancelData() {
      this.getData()
    },
  },
}
</script>
